import React from 'react';
import { Button } from '../ui/button';
import { Bell } from 'lucide-react';

const MobileWebviewHeader = ({ clientName, clientLogo }) => {
  const platformLogo = '../assets/img/transparent-Photoroom.png';

  return (
    <header className="sticky top-0 z-40 bg-primary px-4 py-3 w-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3 min-w-0">
          <img
            src={platformLogo}
            alt="Adler Local"
            className="h-8 w-8 object-contain shrink-0"
          />
          <div className="min-w-0">
            <h1 className="text-base font-bold text-primary-foreground leading-tight truncate">
              My Business
            </h1>
            <p className="text-xs text-primary-foreground/70 truncate">
              {clientName}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-10 w-10 rounded-full text-primary-foreground hover:bg-primary-foreground/10">
            <Bell className="h-5 w-5" />
          </Button>
          <div className="h-9 w-9 rounded-full overflow-hidden ring-2 ring-primary-foreground/30 bg-primary-foreground/10">
            <img
              src={clientLogo}
              alt={clientName}
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default MobileWebviewHeader;
